import "./Contact.css";

import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";


function Contact(){


return(


<div className="contact-page">



<section className="contact-hero">

<h1>
Contact Us 🤍
</h1>

<p>
We would love to hear from you! 
Need help with your order or have a question?
</p>

</section>





<div className="contact-container">



<div className="contact-info">



<h2>
Get In Touch
</h2>



<div className="info-card">

<FaPhone/>

<div>
<h3>
Phone
</h3>

<p>
+961  79 427 021
</p>

</div>

</div>





<div className="info-card">

<FaEnvelope/>

<div>

<h3>
Email
</h3>

<p>
Cuties2026@gmail.com
</p>

</div>

</div>






<div className="info-card">

<FaMapMarkerAlt/>

<div>

<h3>
Location
</h3>

<p>
Lebanon
</p>

</div>

</div>



</div>







<form className="contact-form">


<h2>
Send Message 💌
</h2>


<input
type="text"
placeholder="Your Name"
/>


<input
type="email"
placeholder="Your Email"
/>



<input
type="text"
placeholder="Phone Number"
/>



<textarea

placeholder="Your Message"

/>



<button>

Send Message

</button>



</form>



</div>



</div>


)

}


export default Contact;